// extracted by mini-css-extract-plugin
export default {"languageDropdown":"jMoJs","controlIcon":"z5IEw","menuItemIcon":"wqkgj","menuItemLabel":"Lbzlb"};